'use client'

import { useEffect, useRef, useState } from "react"
import styles from './ua.module.scss'
import Button from "../button/Button"
import Dropdown from "../dropdown/Dropdown"
import Form from "../form/Form"
import Field from "../form/Field"
import { formatNumber } from "@/utils/Formatters"
import Icon from "../icon/Icon"
import StackedPanel from "../panel/StackedPanel"
import PanelBody from "../panel/PanelBody"

export default function MileageButton(props) {
  
  const [selected,setSelected] = useState(props.filters.max_miles || '')
  const [salt,setSalt] = useState(new Date().getTime())
  
  const ddMileage = useRef()
  const [options,setOptions] = useState([])
  
  useEffect(() => {
    setSelected(props.filters.max_miles)
    setSalt(new Date().getTime())
    setOptions([
      { id: 100000, label: formatNumber(100000) },
      { id: 75000, label: formatNumber(75000) },
      { id: 50000, label: formatNumber(50000) },
      { id: 40000, label: formatNumber(40000) },
      { id: 30000, label: formatNumber(30000) },
      { id: 25000, label: formatNumber(25000) },
      { id: 20000, label: formatNumber(20000) },
      { id: 15000, label: formatNumber(15000) },
      { id: 10000, label: formatNumber(10000) },
      { id: 5000, label: formatNumber(5000) },
    ])
  }, [props.filters.max_miles])
  
  const toggle = (e) => {
    if (e) e.preventDefault()
    ddMileage.current.toggle()
  }
  
  const onSubmit = (value) => {
    setSelected(value)
    if (value) {
      props.listingRef.current.applyFilters({ max_miles: value })
    } else {
      props.listingRef.current.applyFilters({ max_miles: null })
    }
    toggle()
  }
  
  return <>
    <Button  theme={["filter-icon", "filter-icon-wide", (selected ? 'filter-on' : '')]} onClick={e => toggle(e) } label="Filter by Mileage">
      <Icon {...props} name="mileage"></Icon>
      <span>{ 'Mileage' }</span>
    </Button>
    <Dropdown {...props} ref={ddMileage} position={'left'} body={'padded'} offset={'12px'} title="Filter by Mileage">
      <Form id="filter_mileage" name="Mileage Filter">
        <StackedPanel>
          <PanelBody padded={true}>
            <div className={ styles.mlg }>
              <div className="flex-col">Maximum Mileage</div>
              <div className="flex-col">
                <Field key={salt} type="select" allowEmpty={true} name="mileage" options={options} label={'Max Mileage'} value={selected} onChange={value => onSubmit(value)}></Field>
              </div>
            </div>
          </PanelBody>
        </StackedPanel>
      </Form>
    </Dropdown>
  </>
  
}